(function () {
  if (window.__klFx) { window.__klFx.scan(); return; }
  var d = document, root = d.documentElement;
  root.classList.add('kl-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var io = null;

  function runCount(el) {
    var end = parseFloat(el.getAttribute('data-kl-count')) || 0;
    if (reduce || end === 0) { el.textContent = end; return; }
    var start = null, dur = 1400;
    function tick(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function onIn(entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('kl-in');
      if (el.hasAttribute('data-kl-count')) runCount(el);
      io.unobserve(el);
    });
  }

  function scan() {
    var els = d.querySelectorAll('.kl-reveal:not(.kl-seen), [data-kl-count]:not(.kl-seen)');
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('kl-seen');
      if (!io || reduce) {
        el.classList.add('kl-in');
        if (el.hasAttribute('data-kl-count')) el.textContent = el.getAttribute('data-kl-count');
        return;
      }
      if (el.hasAttribute('data-kl-count')) el.textContent = '0';
      io.observe(el);
    });
  }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(onIn, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
  }

  var bar = null, ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var h = root.scrollHeight - window.innerHeight;
      bar = bar || d.querySelector('[data-kl-progress]');
      if (bar && h > 0) bar.style.transform = 'scaleX(' + Math.min(window.pageYOffset / h, 1) + ')';
      if (!reduce) {
        var px = d.querySelectorAll('[data-kl-parallax]');
        Array.prototype.forEach.call(px, function (el) {
          var r = el.parentNode.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) {
            el.style.transform = 'translate3d(0,' + (-r.top * 0.18) + 'px,0)';
          }
        });
      }
    });
  }

  if (fine && !reduce) {
    d.addEventListener('mousemove', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-kl-tilt]');
      if (t) {
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        t.style.transform = 'rotateY(' + (x * 12) + 'deg) rotateX(' + (-y * 12) + 'deg) scale(1.02)';
      }
      var g = e.target.closest('[data-kl-glow]');
      if (g) {
        var gr = g.getBoundingClientRect();
        g.style.setProperty('--mx', (e.clientX - gr.left) + 'px');
        g.style.setProperty('--my', (e.clientY - gr.top) + 'px');
      }
    }, { passive: true });
    d.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-kl-tilt]');
      if (t && !t.contains(e.relatedTarget)) t.style.transform = '';
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  d.addEventListener('shopify:section:load', function () { scan(); onScroll(); });
  window.__klFx = { scan: scan };
  scan();
  onScroll();
})();